function initTestimonialsReviews() {
    const sliderWrapper = document.querySelectorAll('.testimonials__wrapper');
    sliderWrapper.forEach(wrapper => {
        if (!wrapper) return;

        const id = wrapper.dataset.sectionId;
        const container = wrapper.querySelector('#testimonial-reviews-' + id);
        const nextElement = wrapper.querySelector('.swiper-button-next');
        const prevElement = wrapper.querySelector('.swiper-button-prev');
        const scrollBar = wrapper.querySelector('.swiper-scrollbar');
        const pagination = wrapper.querySelector('.swiper-pagination');

        if (!container) return;

        if (container.swiper) {
            container.swiper.destroy();
        }

        let swiper = new Swiper(container, {
            effect: "slide",
            slidesPerView: 1.075,
            spaceBetween: 16,
            navigation: {
                nextEl: nextElement,
                prevEl: prevElement,
            },
            pagination: {
                el: pagination,
                clickable: true,
            },
            scrollbar: {
                el: scrollBar,
                hide: true,
            },
            breakpoints: {
                700: { slidesPerView: 2 },
                1000: { slidesPerView: 3 },
            },
        });
    });
}
document.addEventListener("DOMContentLoaded", function () {
    initTestimonialsReviews();
});